// extracted by mini-css-extract-plugin
export default {"galleryUploadErrorPopup":"GalleryUploadErrorPopup_galleryUploadErrorPopup__FFA-V","popupContent":"GalleryUploadErrorPopup_popupContent__xVkf7"};